export const STORAGE_KEYS = {
  FOGO_LIMITS: 'FOGO_LIMITS',
  AUTO_COMPLETE_BYPASS: 'AUTO_COMPLETE_BYPASS',
} as const;

export type STORAGE_KEYS_TYPE = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];

const PREDEFINED_HOST = 'CHRONO_KINGDOMS';

const getStorageKey = (key: STORAGE_KEYS_TYPE) => `${PREDEFINED_HOST}:${STORAGE_KEYS[key]}`;

export const storage = {
  get: <T>(key: STORAGE_KEYS_TYPE, defaultValue: T): T => {
    const value = localStorage.getItem(getStorageKey(key));
    if (value === null) return defaultValue;
    try {
      const res = JSON.parse(value) as { timestamp?: number; value: T };
      if (res.timestamp && res.timestamp <= Date.now()) {
        storage.del(key);
        return defaultValue;
      }
      return res.value;
    } catch {
      return value as unknown as T;
    }
  },
  set: <T>(key: STORAGE_KEYS_TYPE, value: T, expires?: Date): boolean => {
    try {
      localStorage.setItem(
        getStorageKey(key),
        JSON.stringify({
          timestamp: expires?.getTime(),
          value,
        }),
      );
      return true;
    } catch (error) {
      console.error('Failed to save to localStorage:', error);
      return false;
    }
  },
  del: (key: STORAGE_KEYS_TYPE): boolean => {
    try {
      localStorage.removeItem(getStorageKey(key));
      return true;
    } catch (error) {
      console.error('Failed to delete from localStorage:', error);
      return false;
    }
  },
  clear: (): void => localStorage.clear(),
};
